import { ConstraintSku, Constraint } from "@/types";

export const CONSTRAINTS: { [K in ConstraintSku]: Constraint } = {
  "constraint-anything": {
    input: "text",
    name: "Anything Goes",
    sku: "constraint-anything",
    topics: 3,
  },
  "constraint-adjective": {
    input: "text",
    name: "One Adjective",
    sku: "constraint-adjective",
    topics: 3,
  },
  "constraint-business-name": {
    input: "text",
    name: "A Business Name",
    sku: "constraint-business-name",
    topics: 3,
  },
  "constraint-emojis": {
    input: "emoji",
    name: "Emojis",
    sku: "constraint-emojis",
    topics: 3,
  },
  "constraint-emotion": {
    input: "text",
    name: "Two Emotions",
    sku: "constraint-emotion",
    topics: 3,
  },
  "constraint-proper-noun": {
    input: "text",
    name: "One Proper Noun",
    sku: "constraint-proper-noun",
    topics: 3,
  },
  "constraint-question": {
    input: "text",
    name: "A Question",
    sku: "constraint-question",
    topics: 3,
  },
};

export default class Constraints {
  static from(sku: ConstraintSku) {
    return CONSTRAINTS[sku];
  }

  static get constraintList() {
    return CONSTRAINTS;
  }
}
